import { Badge, Button, Group, Loader, Pagination, Text } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { EventItem } from "./EventItem";
import classes from "./WorkspaceDashboard.module.css";

export function EventList({
  events,
  pagination,
  onPageChange,
  currentEventId,
  onSelectEvent,
  onCreateEvent,
  isAdmin,
  isPending,
  statusColor,
}) {
  return (
    <>
      <Group justify="space-between" mb="md">
        <Group gap="sm">
          <Text fw={700} size="lg">
            Events
          </Text>
          <Badge variant="outline" size="sm">
            {pagination?.total || 0}
          </Badge>
        </Group>
        {isAdmin && (
          <Button
            size="xs"
            leftSection={<IconPlus size={16} />}
            onClick={onCreateEvent}
          >
            New Event
          </Button>
        )}
      </Group>

      {isPending ? (
        <Loader size="sm" />
      ) : (
        <div className={classes.eventGrid}>
          {events?.map((event) => (
            <EventItem
              key={event.id}
              event={event}
              isActive={event.id === currentEventId}
              onSelect={onSelectEvent}
              statusColor={statusColor}
              isAdmin={isAdmin}
            />
          ))}

          {events?.length === 0 && (
            <div
              className={classes.createButtonCompact}
              onClick={onCreateEvent}
            >
              <IconPlus size={16} />
              <Text size="sm">No events found. Create your first event.</Text>
            </div>
          )}
        </div>
      )}

      {pagination?.lastPage > 1 && (
        <Group justify="center" mt="lg">
          <Pagination
            total={pagination.lastPage}
            value={pagination.currentPage}
            onChange={onPageChange}
          />
        </Group>
      )}
    </>
  );
}
